import { PrimeNgModule } from "./prime-ng.module";
import { UserDetailsComponent } from "./../components/user-details/user-details.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AddNoteModalComponent } from "./../components/add-note-modal/add-note-modal.component";
import { UpdateLeadStatusModalComponent } from "../components/update-lead-status-modal/update-lead-status-modal.component";
import { AddCommentModalComponent } from "../components/add-comment-modal/add-comment-modal.component";
import { UpdateDematDetailsModalComponent } from "../components/update-demat-details-modal/update-demat-details-modal.component";
import { UpdatePersonalInfoModalComponent } from "../components/update-personal-info-modal/update-personal-info-modal.component";
import { UpdateAddressModalComponent } from "../components/update-address-modal/update-address-modal.component";
import { UpdateBankDetailsModalComponent } from "../components/update-bank-details-modal/update-bank-details-modal.component";
import { UpdatePanModalComponent } from "../components/update-pan-modal/update-pan-modal.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { CustomPagianatorComponent } from "../components/custom-pagianator/custom-pagianator.component";
import { MatSelectModule } from "@angular/material/select";
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from "@angular/material/paginator";
import { MatButtonModule } from "@angular/material/button";
import { AgGridAngular, AgGridModule } from "ag-grid-angular";
import { LoaderComponent } from "../components/loader/loader.component";
import { AddInvestorModalComponent } from "../components/add-investor-modal/add-investor-modal.component";

@NgModule({
  declarations: [
    UserDetailsComponent,
    AddNoteModalComponent,
    UpdateLeadStatusModalComponent,
    AddCommentModalComponent,
    UpdateDematDetailsModalComponent,
    UpdatePersonalInfoModalComponent,
    UpdateAddressModalComponent,
    UpdateBankDetailsModalComponent,
    UpdatePanModalComponent,
    CustomPagianatorComponent,
    LoaderComponent,
    AddInvestorModalComponent,
  ],
  imports: [
    CommonModule,
    PrimeNgModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSelectModule,
    MatButtonModule,
    AgGridModule,
    AgGridAngular,
  ],
  exports: [
    UserDetailsComponent,
    LoaderComponent,
    AddNoteModalComponent,
    UpdateLeadStatusModalComponent,
    AddCommentModalComponent,
    AddInvestorModalComponent,
    UpdateDematDetailsModalComponent,
    UpdatePersonalInfoModalComponent,
    UpdateAddressModalComponent,
    UpdateBankDetailsModalComponent,
    UpdatePanModalComponent,
    FormsModule,
    ReactiveFormsModule,
    CustomPagianatorComponent,
    AgGridModule,
    AgGridAngular,
  ],
  providers: [
    {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: {
        pageSizeOptions: [5, 10, 25, 100],
        showFirstLastButtons: false,
      },
    },
  ],
})
export class SharedModule {}
